export default {
  namespaced: true,
  actions: {
    uploadFile(_, file) {
      return this.$api.files.uploadFile(file).then(r => r.data?.data || {})
    }
  }
}
